import { getMaximumCoinsurance, getMaximumCopay } from './insuranceDetails';
import { IN_NETWORK, OUT_OF_NETWORK } from '../../../../../constants/index';
import { isEmpty } from '../../../../../core/util/empty';

export const getCopayCoinsuranceSwimlaneTitle = (props: any) => {
  const copayInNetworkValue = getMaximumCopay(props.insuranceDetails, IN_NETWORK);
  const copayOutOfNetworkValue = getMaximumCopay(props.insuranceDetails, OUT_OF_NETWORK);
  const coinsuranceInNetworkValue = getMaximumCoinsurance(props.insuranceDetails, IN_NETWORK);
  const coinsuranceOutOfNetworkValue = getMaximumCoinsurance(
    props.insuranceDetails,
    OUT_OF_NETWORK
  );

  const copayAndCoinsuranceDontExist =
    ((isEmpty(copayInNetworkValue) || copayInNetworkValue === 0) &&
      isEmpty(coinsuranceInNetworkValue)) ||
    ((isEmpty(copayOutOfNetworkValue) || copayOutOfNetworkValue === 0) &&
      isEmpty(coinsuranceOutOfNetworkValue));

  if (copayAndCoinsuranceDontExist) {
    return 'Copay & coinsurance';
  }

  return "What you'll pay";
};
